<app-product-push-list-atom
  [displayContext]="displayContext()"
  [products]="products()"
  [productNameColor]="productNameColor()"
  [productDescriptionColor]="productDescriptionColor()"
  [productPriceColor]="productPriceColor()"
  [productImagePlaceholderColor]="productImagePlaceholderColor()"
  [productBorderColor]="productBorderColor()"
  [productBackgroundColor]="productBackgroundColor()"
  [productHoverColors]="productHoverColors()"
  [tagColors]="tagColors()"
  (requestGoToProduct)="requestGoToProduct($event)"
></app-product-push-list-atom>
